<template>
	<svg :width="width" :height="height" viewBox="0 0 64 64" :fill="color" xmlns="http://www.w3.org/2000/svg">
		<g>
			<g transform="matrix(1,0,0,1,-1024,-256)">
				<g>
					<g transform="matrix(0.866025,0.5,-0.5,0.866025,589.93,-387.292)">
						<g transform="matrix(1,0,0,1,0,-0.699553)">
							<path d="M737.673,328.231C738.494,328.056 739.334,328.427 739.757,329.152C739.955,329.463 740.106,329.722 740.106,329.722C740.106,329.722 745.206,338.581 739.429,352.782C737.079,358.559 736.492,366.083 738.435,371.679C738.697,372.426 738.482,373.258 737.89,373.784C737.298,374.31 736.447,374.426 735.735,374.077C730.192,371.375 722.028,365.058 722.021,352C722.015,340.226 728.812,330.279 737.673,328.231ZM737.049,332.302C730.104,335.24 726.021,342.847 726.021,352C726.021,359.27 730.203,365.111 734.111,368.315C733.195,363.785 733.062,357.818 735.724,351.274C739.116,342.936 737.912,335.324 737.049,332.302Z"></path>
						</g>
						<g transform="matrix(-1,0,0,-1,1483.03,703.293)">
							<path d="M737.609,328.246C738.465,328.06 739.344,328.446 739.785,329.203C739.97,329.49 740.106,329.722 740.106,329.722C740.106,329.722 745.206,338.581 739.429,352.782C737.1,358.507 736.503,365.948 738.383,371.527C738.646,372.304 738.415,373.164 737.796,373.703C737.177,374.243 736.294,374.356 735.56,373.989C730.02,371.241 722.028,364.92 722.021,352C722.016,340.255 728.779,330.328 737.609,328.246ZM737.049,332.302C730.104,335.24 726.021,342.847 726.021,352C726.021,359.27 730.203,365.111 734.111,368.315C733.195,363.785 733.062,357.818 735.724,351.274C739.116,342.936 737.912,335.324 737.049,332.302Z"></path>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'CoffeeIcon',
	props: {
		width: {
			type: Number,
			default: 32,
		},
		height: {
			type: Number,
			default: 32,
		},
		color: {
			type: String,
			default: 'black',
		},
	},
}
</script>
